/* eslint-disable react-hooks/exhaustive-deps */
import { useContext } from "react";
import Context from "../FetchMarksContext";

const useFetchMarks = () => useContext(Context);

export default useFetchMarks;
